import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import {
  ErrorMessageResources,
  ErrorTitleResources,
  MappingRequestResources,
  PointTransferHisotyResources,
  PointTransferResources,
} from "./intl";

const resources = {
  jp: {
    translation: {
      DEFAULT__TITLE: "読み込み中",
      LANGUAGES: "言語",
      LOGIN: "ログイン",
      LOGIN_HERE_CREW: "ログインの方はこちら",
      LOGIN_HERE_DRIVER: "ログインはこちら",
      LOGOUT: "ログアウト",
      QUIT_GO_CREW_PORTAL: "GO乗務員ポータルを終了する",
      QUIT_GO_DRIVER_PORTAL: "GOドライバーポータルを終了する",
      EXECUTE_LOGOUT: "ログアウトする",
      ASK_LOGOUT: "ログアウトをしますか？",
      CANCEL: "キャンセル",
      EDIT: "変更",
      SETTINGS: "設定",
      WELCOME_BACK: "ようこそ",
      CONTACT: "お問い合わせ",
      MAKE_CONTACT: "問い合わせる",
      INTERNAL_SERVER_ERROR: "エラーが発生しました",
      INTERNAL_SERVER_ERROR_EXAMPLE: "申し訳ありませんが、しばらく経ってからやり直してください。",
      UNAUTHORIZED: "セッションが切れました",
      UNAUTHORIZED_EXAMPLE: "お手数ですが再度ログインをお願いします。",
      PAGE_NOT_FOUND: "指定されたURLのページが見つかりません",
      PAGE_MIGHT_REMOVED: "お探しのページは削除された可能性があります。",
      SERVICE_UNAVAILABLE: "メンテナンス中",
      SERVICE_UNAVAILABLE_EXAMPLE: "申し訳ありませんが、しばらく経ってからやり直してください。",
      RETURN_TO_LOGIN: "ログイン画面に戻る",
      CREW_PORTAL: "乗務員ポータル",
      DEFAULT_CREW_TITLE: "GO乗務員ポータル",
      DRIVER_PORTAL: "ドライバーポータル",
      DEFAULT_DRIVER_TITLE: "GOドライバーポータル",
      SEND: "送信する",
      TOP: "TOP",
      TO_TOP: "TOPへ",
      POINT: "ポイント",
      NOTIFICATION: "お知らせ",
      MY_PAGE: "マイページ",
      ACCOUNT_REGISTRATION: "アカウント登録",
      TO_ACCOUNT_REGISTRATION: "アカウント登録へ",
      ACCOUNT_REGISTRATION_HERE: "アカウント登録の方はこちら",
      WHAT_IS_ACCOUNT_REGISTRATION: "アカウント登録方法について",
      WHAT_IS_PHONE_NUMBER_CHANGE: "携帯電話番号が変更できません",
      WHAT_IS_MAIL_ADDRESS_CHANGE: "メールアドレスが変更できません",
      SEE_MY_PAGE: "マイページを見る",
      TO_MY_PAGE: "マイページへ",
      ACCOUNT: "アカウント",
      CREW_NUMBER: "乗務員番号",
      DRIVER_NUMBER: "乗務員番号",
      ERROR: "エラー",
      ERROR_FEE: "エラー手数料",
      POINT_EXCHANGE: "ポイント交換",
      POINT_EXCHANGE_OF_GO_CREW: "GO乗務員ポイント交換",
      POINT_EXCHANGE_OF_GO_DRIVER: "GOドライバーポイント交換",
      OWNED_POINT: "保有ポイント",
      POINT_EXPIRE: "% 日以内で期限が切れるポイントが【 % 】ポイントあります！",
      SEE_EXPIRE_POINT: "ポイントの有効期限を確認する",
      EXCHANGE_POINT: "ポイントを交換する",
      ONE_TIME_REMITTANCE_FEE_IS_WAIVED: "送金手数料1回分無料(半年に1回）",
      POINTS_EXPIRING_SOON: "有効期限の近いポイント",
      CHECK_APPLICATION_STATUS: "申請状況を確認する",
      EARNED_POINT: "獲得ポイント",
      TIP: "チップ",
      EARN: "獲得",
      EXPIRE: "失効",
      APPLY: "申請",
      RETURN: "返却",
      SEE_POINT_HISTORY: "ポイント実績を見る",
      SEE_MORE_NOTIFICATION: "お知らせをもっと見る",
      BACK_TO_LIST: "一覧に戻る",
      SUPPORT: "サポート",
      PRIVACY_POLICY: "プライバシーポリシー",
      TERMS_OF_CREW_USE: "GO乗務員ポイント規約",
      TERMS_OF_DRIVER_USE: "利用規約",
      MANUAL: "マニュアル",
      CUSTOMER_NAME: "% 様",
      UNREAD: "未読",
      POINT_EXPIRE_TO: "ポイントの期限切れまで",
      AFTER_MONTH: "あと%1~%2ヶ月で期限切れ",
      AFTER_MONTH_2: "%1~%2ヶ月",
      AFTER_DAY: "あと%日以内で期限切れ",
      AFTER_DAY_2: "%日以内",
      UNTIL_DATE: "%失効",
      PLEASE_AUTHENTICATE: "アカウント登録のための認証を行ってください",
      PLEASE_INPUT: "下記項目を入力して認証を行ってください。",
      PHONE_NUMBER: "携帯電話番号",
      PHONE_NUMBER_EXAMPLE: "090 1234 5678",
      PHONE_NUMBER_REQUIRED: "携帯電話番号は必須です",
      PHONE_NUMBER_VALID: "有効な携帯電話番号を入力してください",
      PHONE_NUMBER_NOTE: "ハイフン(-)なしで入力してください",
      PIN_CODE: "認証コード",
      PIN_CODE_NOTE: "認証コードは乗務員アプリから発行し、SMS(メッセージ)で送られてきた4ケタの数字です",
      PIN_CODE_VALID: "有効な認証コードを入力してください",
      PIN_CODE_REQUIRED: "認証コードは必須です",
      AUTHENTICATE: "認証する",
      CONFIRM_CODE_VALID: "有効な確認コードを入力してください",
      CONFIRM_CODE_REQUIRED: "確認コードは必須です",
      ALREADY_HAVE_ACCOUNT: "すでにアカウントをお持ちの方",
      PLEASE_INPUT_EMAIL: "メールアドレスを入力してください",
      PLEASE_INPUT_EMAIL_EXAMPLE:
        "「GO乗務員ポータル」に登録するメールアドレスを入力してください。確認用のメールを送信します。",
      EMAIL: "メールアドレス",
      EMAIL_REQUIRED: "メールアドレスは必須です",
      EMAIL_INVALID: "メールアドレスの形式が正しくありません。",
      EMAIL_TOO_LONG: "254文字以下で入力してください。",
      CREW_NUMBER_VALID: "有効な乗務員番号を入力してください",
      CREW_NUMBER_REQUIRED: "乗務員番号は必須です",
      CREW_NUMBER_NOTE: "乗務員アプリで開局時に入力する番号を入力してください",
      AUTH_MAIL: "メールアドレス入力",
      CHANGE_EMAIL: "メールアドレス変更",
      CHANGE_PHONE_NUMBER: "携帯電話番号変更",
      CHANGE_PASSWORD: "パスワード変更",
      EMAIL_SENT: "メールアドレス登録確認のメールを送りました。メール内容をご確認ください。",
      EMAIL_SUCCESS: "メールアドレスを変更しました",
      PHONE_NUMBER_SUCCESS: "携帯電話番号を変更しました",
      PASSWORD_SUCCESS: "パスワードを変更しました",
      REGISTRATION_SUCCESS: "GO乗務員ポータルのアカウント登録が完了しました",
      FEATURE_PHONE: "フィーチャーフォン(スマートフォン・パソコン以外)の方は次へを押してください。",
      NEXT: "次へ進む",
      PLEASE_INPUT_CONFIRM_CODE_BY_SMS: "SMS(メッセージ)で受け取った確認コードを入力してください",
      CONFIRM_CODE_SENT_BY_SMS:
        "確認コードを携帯電話番号のSMS(メッセージ)に送信しました。\n確認コード4桁の数字を30分以内に入力してください。",
      PLEASE_INPUT_CONFIRM_CODE_BY_EMAIL: "メールで受け取った確認コードを入力してください",
      CONFIRM_CODE_SENT_BY_EMAIL: "確認コードをメールに送信しました。確認コード4桁の数字を30分以内に入力してください。",
      CONFIRM_CODE: "確認コード",
      CONFIRM_CODE_NOT_SENT: "確認コードが届かない、確認が通らない場合は再度確認コードを送信してください。",
      WHO_DO_NOT_RECEIVE_CONFIRM_CODE: "確認コードのメールが届きません",
      WHO_DO_NOT_RECEIVE_CONFIRM_CODE_OR_CHALLENGE_RESENDING:
        "メールアドレスを間違えた、確認が通らない、確認コードを再送信する方",
      WHAT_IS_CONFIRM_CODE: "確認コードとは何ですか?",
      TRY_AGAIN: "もう一度やり直す",
      CONTACT_US: "何度もこの画面が出る場合は、下記より問い合わせをお願いします。",
      CONTACT_US_WEB: "Webで問い合わせる",
      PLEASE_INPUT_PASSWORD: "新しいパスワードを設定してください",
      PASSWORD: "パスワード",
      PASSWORD_REQUIRED: "パスワードは必須です",
      PASSWORD_TOO_SHORT: "8文字以上で入力してください。",
      PASSWORD_TOO_LONG: "64文字以内で入力してください。",
      PASSWORD_CONFIRM_VALID: "パスワードが一致しません。",
      PASSWORD_CONFIRM_REQUIRED: "パスワード(確認用)は必須です。",
      PASSWORD_EXAMPLE: "8文字以上、英字・数字の組み合わせで設定してください",
      PASSWORD_CONFIRM: "パスワード(確認用)",
      SHOW_PASSWORD: "パスワードを表示する",
      REGISTER: "登録する",
      SET: "設定する",
      REGISTER_ACCOUNT: "アカウントを登録する",
      WHO_DO_NOT_HAVE_ACCOUNT: "まだアカウントがない方",
      ACCOUNT_REGISTERED: "GO乗務員ポータルのアカウント登録が完了しました",
      ACCOUNT_REGISTERED_EXAMPLE: "アカウント登録の完了メールが送信されていますのでご確認ください。",
      BOOKMARK_THIS_PAGE: "このページをブックマークしておくことをお勧めします。",
      AUTHENTICATION_FAILED: "認証ができません",
      AUTHENTICATION_FAILED_EXAMPLE: "認証コードを確認の上、もう一度やり直してください。",
      AUTHENTICATION_CODE_INVALIDATED: "認証コードが無効化されました",
      AUTHENTICATION_CODE_INVALIDATED_EXAMPLE: "認証コードの入力に規定回数失敗したため、認証コードが無効化されました。",
      AUTHENTICATION_CODE_INVALIDATED_EXAMPLE2: "認証コード発行から24時間語に新しい認証コードが発行できます。",
      AUTHENTICATION_CODE_INVALIDATED_EXAMPLE3: "時間をおいてやり直してください。",
      AUTHENTICATION_CODE_INVALIDATED_EXAMPLE4: "認証コードを再発行する方法は、よくあるご質問をご確認ください。",
      FAQ: "よくある質問",
      AUTHENTICATION_CODE_EXPIRED: "認証コードの有効期限が切れています",
      AUTHENTICATION_CODE_EXPIRED_EXAMPLE: "乗務員アプリより、再度認証コードを送信してください。",
      EMAIL_ALREADY_REGISTERED: "このメールアドレスは、すでにGO乗務員ポータルのアカウントに登録されています",
      EMAIL_ALREADY_REGISTERED_EXAMPLE: "入力をご確認の上、もう一度やり直してください。",
      CONFIRM_FAILED: "確認ができません",
      CONFIRM_FAILED_EXAMPLE: "確認コードを確認の上、もう一度やり直してください。",
      CONFIRM_CODE_EXPIRED: "確認コードの有効期限が切れています",
      CONFIRM_CODE_EXPIRED_EXAMPLE: "再度、確認コードを送信してください。",
      ACCOUNT_REGISTRATION_FAILED: "アカウント登録ができません",
      ACCOUNT_REGISTRATION_FAILED_EXAMPLE: "お手数ですが下記より問い合わせをお願いします。",
      FORGOT_PASSWORD: "パスワードを忘れた方",
      RESET_PASSWORD: "パスワードを再設定する",
      TO_RESET_PASSWORD: "パスワード再設定へ",
      PASSWORD_NOTE: "半角英字・数字の両方を含む8文字以上で入力してください",
      PASSWORD_CONFIRM_NOTE: "確認のため、上で入力したパスワードと同じものを入力してください",
      WHO_CHANGED_PHONE_NUMBER: "携帯電話番号を変更した方",
      DO_CHANGE_EMAIL: "メールアドレスを変更する",
      WHO_CHANGED_EMAIL: "メールアドレスを変更した方",
      CANNOT_LOGIN: "ログインできない方",
      PASSWORD_INVALID: "半角英数字または（記号）で入力してください。",
      PASSWORD_INVALID_MIXED: "英字・数字の組み合わせで入力してください。",
      PHONE_OR_PASSWORD_INVALID: "携帯電話番号またはパスワードが正しくありません。",
      CONFIRM_CODE_MAX: "確認コードの文字数が最大値を超えています",
      CONFIRM_CODE_MIN: "確認コードの文字数が最小値を下回っています",
      ACCOUNT_LOCKED: "アカウントがロックされました",
      ACCOUNT_LOCKED_EXAMPLE_1: "規定回数ログイン失敗に失敗したため、アカウントがロックされました。",
      ACCOUNT_LOCKED_EXAMPLE_2: "パスワードを再設定し、ロックを解除してください。",
      WHAT_IS_ACCOUNT_LOCKED: "アカウントロックがかかりました",
      RESET_PASSWORD_EXAMPLE: "パスワードの再設定を行います",
      PLEASE_INPUT_EXAMPLE: "下記項目を入力してください。",
      PLEASE_INPUT_EXAMPLE_AUTH: "下記項目を入力して認証を行ってください。",
      PLEASE_SEND_PIN_CODE: "本人認証のため認証コードを送信してください",
      EMAIL_SENT_FOR_AUTHENTICATION: "本人認証のためメールを送信しました",
      EMAIL_SENT_FOR_CONFIRMATION: "メールアドレスの本人確認のためメールを送信しました",
      PLEASE_SEND_PIN_CODE_BY_EMAIL: "登録済みのメールアドレスに認証コードを送信します。",
      PLEASE_CHECK_YOUR_EMAIL: "メールを確認の上、メール文の案内にそって手続きを進めてください。",
      SMS_SENT_FOR_AUTHENTICATION: "本人認証のためSMS(メッセージ)を送信しました",
      PLEASE_SEND_PIN_CODE_BY_SMS: "登録済みの携帯電話番号のSMS(メッセージ)に認証コードを送信します。",
      PLEASE_CHECK_YOUR_SMS: "SMS(メッセージ)を確認の上、SMS文の案内にそって手続きを進めてください。",
      SEND_PIN_CODE: "認証コードを送信する",
      PLEASE_INPUT_PIN_CODE: "メールで受け取った認証コードを入力してください",
      PIN_CODE_SENT_EXAMPLE: "認証コードをメールに送信しました。認証コード4桁の数字を30分以内に入力してください。",
      PIN_CODE_NOT_SENT_EXAMPLE: "認証コードが届かない場合は、再度認証コードを送信してください。",
      SEND_PIN_CODE_AGAIN: "認証コードを再送信する",
      WHO_DO_NOT_RECEIVE_PIN_CODE: "認証コードのメールが届きません",
      WHO_DO_NOT_RECEIVE_PIN_CODE_OR_CHALLENGE_RESENDING: "認証が通らない、認証コードを再送信する方",
      WHAT_IS_PIN_CODE: "認証コードとは何ですか?",
      PLEASE_INPUT_NEW_EMAIL: "新しいメールアドレスを入力してください",
      SEND_CONFIRM_MAIL: "確認用のメールを送信します。",
      PLEASE_INPUT_NEW_PHONE_NUMBER: "新しい携帯電話番号を入力してください",
      SEND_CONFIRM_SMS: "確認用のSMS(メッセージ)を送信します。",
      PLEASE_REGISTER_NEW_PASSWORD: "新しいパスワードを登録してください",
      NEW_PASSWORD: "新しいパスワード",
      NEW_PASSWORD_CONFIRM: "新しいパスワード(確認用)",
      PASSWORD_RESET_SUCCESS: "パスワードの再設定が完了しました",
      PASSWORD_RESET_FAILED: "パスワードの再設定ができません",
      PASSWORD_RESET_FAILED_EXAMPLE: "お手数ですが下記よりお問い合わせをお願いします。",
      PIN_CODE_INVALIDATED: "認証コードが無効化されました",
      PIN_CODE_INVALIDATED_EXAMPLE_1: "認証コードの入力に規定回数失敗したため、コードが無効化されました。",
      PIN_CODE_INVALIDATED_EXAMPLE_2: "また、新しい認証コードは発行にもロックがかかりました。",
      PIN_CODE_INVALIDATED_EXAMPLE_3: "時間をおいてやり直してください。",
      POINT_EXCHANGE_APPLICATION: "ポイント交換申請",
      POINT_EXCHANGE_APPLICATION_HISTORY: "ポイント交換申請履歴",
      POINT_EARN_HISTORY: "ポイント獲得履歴",
      POINT_EXCHANGE_APPLICATION_HISTORY_EXAMPLE: "申請状況はポイント交換申請履歴より確認ください。",
      POINT_EXCHANGE_APPLICATION_HISTORY_EMPTY: "申請履歴がありません",
      POINT_EXCHANGE_APPLICATION_HISTORY_EXPIRY: "ポイント交換申請履歴の表示期限は１年間です。",
      SEE_APPLICATION_HISTORY: "この申請履歴を確認する",
      POINT_EXCHANGE_APPLICATION_FAILED_1: "ポイント交換申請ができませんでした",
      POINT_EXCHANGE_APPLICATION_FAILED_2: "お手数ですが、もう一度はじめからやり直しをお願いします。",
      BACK_TO_TOP: "TOPに戻る",
      RECEIVE_METHOD: "受取方法",
      BANK_TRANSFER: "銀行振込",
      EXCHANGE_TO_CASH: "現金へ交換します。",
      BANK_TRANSFER_EXAMPLE_1: "銀行口座に振り込まれるまで1~5営業日かかります。",
      BANK_TRANSFER_SCHEDULE: "銀行口座の振込スケジュール",
      REMITTANCE_FEE: "送金手数料",
      ONCE_FREE: "1回分無料",
      EXCHANGEABLE_POINT: "交換可能ポイント",
      POINT_TO_YEN: "※1P=1円",
      POINT_EXPIRE_IN: "あと % 日以内で切れるポイント",
      EXCHANGE_AMOUNT: "交換金額",
      PLEASE_INPUT_EXCHANGEABLE_POINT: "交換可能ポイントの金額を入力してください",
      YEN: "円",
      CONFIRM_APPLICATION_CONTENTS: "申請内容を確認する",
      TOTAL_CONSUMPTION_POINT: "消費ポイント総額",
      BREAKDOWN: "内訳",
      OTHER: "営業協力金", // その他
      BANK_ACCOUNT: "振込先口座",
      BANK: "銀行",
      BRANCH_NAME: "支店名",
      ACCOUNT_TYPE: "口座種別",
      ACCOUNT_NUMBER: "口座番号",
      ACCOUNT_NAME: "口座名義",
      BANK_ACCOUNT_EXAMPLE_1: "振込先の口座情報は、GMO-PG送金サービスサイトにて登録ください。",
      BANK_ACCOUNT_EXAMPLE_2: "申請後、<strong>ユーザー番号</strong>が携帯電話番号のSMS(メッセージ)に届きます。",
      BANK_ACCOUNT_EXAMPLE_3: "ユーザー番号は口座情報の認証時に必要です。",
      APPLY_WITH_THIS_CONTENTS: "この内容で申請する",
      USER_NUMBER_SENT_TO_SNS: "SNS(メッセージ)にユーザー番号が届きます",
      BACK_AND_CHANGE_CONTENTS: "戻って内容を変更する",
      APPLICATION_NOT_COMPLETED_YET: "まだ申請は完了していません",
      REGISTER_BANK_ACCOUNT: "振込先口座を登録する",
      MOVE_TO_GMO_PG: "GMO-PG送金サービスサイトへ移動",
      USER_NUMBER_NOT_SENT: "ユーザー番号が届かない場合は、下記ボタンより再度ユーザー番号を送信してください。",
      SEND_USER_NUMBER_AGAIN: "ユーザー番号を再送信する",
      CANCEL_APPLICATION: "ポイント交換申請をやめる",
      POINT_EXCHANGE_APPLICATION_ACCEPTED: "ポイント交換申請を受け付けました",
      APPLICATION_ID: "申請ID",
      BANK_TRANSFER_EXAMPLE_2: "銀行振込の場合、銀行口座に振り込まれるまで1~5営業日かかります。",
      BANK_TRANSFER_EXAMPLE_3: "銀行振込は、ポイント交換申請の前にGMO-PGサイトにて振込先口座の登録が必要です。",
      POINT_HISTORY: "ポイント獲得履歴",
      POINT_TRANSFER_SUMMARY: "年間ポイント交換情報",
      TRANSFER_AMOUNT: "振込金額",
      TRANSFER_FEE: "振込手数料",
      TEN_PERCENT_TAX_RATE: "10%対象・消費税",
      FEE_BREAKDOWN: "手数料内訳",
      FEE_WITH_TAX: "送金手数料とエラー手数料には消費税10％が含まれています",
      TOTAL: "合計",
      FEE_TOTAL: "手数料合計",
      ANNUAL_TRANSFER_INFO: "年間ポイント交換情報について",
      CREW_ANNUAL_TRANSFER_PDF_TITLE: "GO乗務員ポイント年間ポイント情報",
      DRIVER_ANNUAL_TRANSFER_PDF_TITLE: "GOドライバーポイント年間ポイント情報",
      DOWNLOAD_PDF: "PDFでダウンロード",
      SEND_PDF_EMAIL: "メールで送る",
      EMAIL_SENT_SUCCESS: "メールを送信しました",
      EMAIL_SENT_TO_CREW_REGISTERED_ADDRESS: "GO乗務員ポータルに登録のメールアドレス宛てに送信しました。",
      EMAIL_SENT_TO_DRIVER_REGISTERED_ADDRESS: "ドライバーポータルに登録のメールアドレス宛てに送信しました。",
      EMAIL_ADDRESS_CONFIRMABLE_ON_MY_PAGE: "メールアドレスはマイページより確認できます。",
      EMAIL_SEND_DAILY_LIMIT_EXCEEDED: "1日の送信上限を超えました。24時間後に再度送信してください。",
      PRIORITY_PASS: "優先パス",
      CANCEL_COMPENSATION: "キャンセル補填",
      AI_RESERVATION: "AI予約",
      PEAK_TIME: "繁忙時間帯",
      EXPIRED: "有効期限切れ",
      POINT_RETURN: "ポイント返却",
      PLEASE_INPUT_PIN_CODE_FROM_SMS: "SMS(メッセージ)で受け取った認証コードを入力してください",
      PIN_CODE_SENT_TO_SMS_EXMAPLE_1: "認証コードを携帯電話番号のSMS(メッセージ)に送信しました。",
      PIN_CODE_SENT_TO_SMS_EXMAPLE_2: "認証コード4桁の数字を30分以内に入力してください。",
      PLEASE_INPUT_PIN_CODE_FROM_EMAIL: "メールで受け取った認証コードを入力してください",
      PIN_CODE_SENT_TO_EMAIL_EXMAPLE:
        "認証コードをメールに送信しました。認証コード4桁の数字を30分以内に入力してください。",
      SKIP_PIN_CODE_INPUT_NEXT_TIME: "次回以降認証コードの入力を省略する",
      PIN_CODE_NOT_SENT_EXAMPLE_2: "認証コードが届かない場合は、下記ボタンより再度認証コードを送信してください。",
      POINT_EXCHANGE_APPLICATION_ERROR: "ポイント交換申請エラー",
      PIN_CODE_EXPIRED: "認証コードの有効期間が切れています",
      PIN_CODE_EXPIRED_EXAMPLE: "はじめからやり直してください。",
      START_OVER: "最初からやり直す",
      TO_POINT_EXCHANGE_APPLICATION: "ポイント交換申請へ",
      POINT_EXCHANGE_APPLICATION_HISTORY_LIST: "申請履歴一覧",
      REMITTANCE_PROCESSING: "手続き中",
      REMITTANCE_COMPLETED: "送金完了",
      REMITTANCE_ERROR: "エラー",
      REMITTANCE_CANCEL: "キャンセル",
      POINT_RETURN_EXAMPLE_1:
        "エラーが発生したためポイントが返却されました。エラー手数料(銀行振込) %Pが保有ポイントから差し引かれました。",
      RETURNED_POINT: "返却ポイント",
      RETURNED_DATE: "返却日",
      POINT_RETURN_EXAMPLE_2: "※返却時点で利用期限が切れているポイントは、返却後は利用できません。",
      POINT_RETURN_EXAMPLE_3: "エラーが発生したためポイントが返却されました。",
      ERROR_HANDLING_FEE: "エラー手数料について",
      PERIOD: "期間",
      FROM: "から",
      TO: "%まで",
      YEAR: "年",
      MONTH: "月",
      APPLICATION_STATUS: "申請状況",
      ALL_APPLICATIONS: "すべての申請",
      FILTER: "絞り込む",
      STATUS: "ステータス",
      ERROR_DETAIL: "エラー詳細",
      ACCOUNT_NUMBER_DIFFERENCE: "口座番号相違",
      PEAK_TIME_RETURN: "繁忙時間帯還元",
      CLOSE: "閉じる",
      WHO_DO_NOT_RECEIVE_SMS: "SMS(メッセージ)が届きません",
      WHO_DO_NOT_RECEIVE_EMAIL: "メールが届きません",
      VALID_HALF_NUM: "半角数字で入力してください。",
      VALID_NUM_LENGTH: "桁数が足りません。正しく入力できているか確認してください。",
      VALID_TOO_LONG: "%文字以内で入力してください。",
      VALID_PHONE_NUMBER_AREA_CODE: "携帯電話番号は070, 080, 090で始まる番号を入力してください。",
      REASON: "理由",
      CONFIRM_BEFORE_CONTACT: "お問い合わせ前に以下の項目を必ずお読みください。",
      CONFIRM_BEFORE_CONTACT_1: "お問い合わせの前に<Link>よくあるご質問</Link>もぜひご確認ください。",
      CONFIRM_BEFORE_CONTACT_2: "すべての項目を入力の上、お問い合わせ内容を送信してください。",
      CONFIRM_BEFORE_CREW_CONTACT: "アカウント情報については、必ず乗務員ご本人様からお問い合わせをお願いします。",
      CONFIRM_BEFORE_DRIVER_CONTACT: "アカウント情報については、必ずドライバーご本人様からお問い合わせをお願いします。",
      _REQUIRED: "は必須です",
      CONTACT_FORM_NOTICE: "異動・所属の営業所が統廃合された方はご確認ください",
      CONTACT_COMMON_FORM_NOTICE_MESSAGE_0:
        "異動や営業所統廃合により所属営業所が変わった方は以下のお手続きが必要となります。",
      CONTACT_COMMON_FORM_NOTICE_MESSAGE_1: "既存のGO乗務員ポータルのアカウントリセット*",
      CONTACT_COMMON_FORM_NOTICE_MESSAGE_2: "新しい乗務員番号でのGO乗務員ポータルへの登録",
      CONTACT_ACCOUNT_FORM_NOTICE_MESSAGE: "※1はお問い合わせ種別「アカウントリセット」を選択し、依頼してください。",
      CONTACT_FORM_NOTICE_MESSAGE:
        "※1は既存のGO乗務員ポータルにログイン後、お問い合わせフォームよりお問い合わせ種別「アカウントリセット」を選択し、依頼してください。",
      CONTACT_TYPE: "お問い合わせ種別",
      ACCOUNT_RESET_REQUEST: "アカウントリセット",
      TELEPHONE_NUMBER: "電話番号",
      TELEPHONE_NUMBER_NOTE: "ハイフン(-)なしで入力してください",
      NAME: "お名前",
      COMPANY_NAME: "所属する会社名",
      COMPANY_NAME_NOTE: "個人タクシーの方の場合は、組合名を入力してください",
      OFFICE_NAME: "所属する営業所名",
      CONTACT_CONTENTS: "お問い合わせ内容",
      CONTACT_CREW_NUMBER_NOTE:
        "・乗務員端末の開局/ログイン時に利用する番号を入力してください\n・乗務員以外の方は0000を入力してください",
      CONTACT_DRIVER_NUMBER_NOTE: "ドライバー以外の方は0000を入力してください",
      CONTACT_NOTICE_CREW_1: "GO乗務員ポイントに関する内容以外はお答えいたしかねます。あらかじめご了承ください。",
      CONTACT_NOTICE_DRIVER_1: "GOドライバーポイントに関する内容以外はお答えいたしかねます。あらかじめご了承ください。",
      CONTACT_NOTICE_2: "迷惑メール対策の設定をおこなわれている場合、当窓口からの返信が届かない場合がございます。",
      CONTACT_NOTICE_3:
        "当窓口からの返信が無い場合は、弊社ドメイン「@goinc.jp」からのメールを受信できるように設定し再度お問い合わせください。操作手順等の詳細はご利用の各キャリアへお問い合わせください。",
      CONTACT_NOTICE_4:
        "送信した内容はサービス向上のため、運営会社であるGO株式会社が確認します。また、内容によっては、タクシー事業者に開示する場合があります。",
      CONTACT_PRIVACY_POLICY_AGREE: "<Link>プライバシーポリシー</Link>に同意する",
      CONTACT_NOTICE_5: "<Link>アカウントリセットに伴う注意事項</Link>",
      CONTACT_RECEIVED: "お問い合わせを受付けました",
      CONTACT_RESPONSE_TIME_NOTICE: "弊社からの回答は、原則1〜2営業日以内に担当者よりメールにて返信致します。",
      UNFILLED_FIELDS_NOTICE: "入力されていない項目があります",
      PRIVACY_POLICY_UNAGREED: "プライバシーポリシーが同意されていません。",
      CONTACT_SUPPORT_HOURS_NOTICE:
        "対応時間:平日9:00〜17:00（土日、祝日、年末年始(12/30~1/4)を除く)\n※対応時間外にご連絡いただきました分につきましては、翌対応日9:00以降に順次ご返信いたします。",
      REQUIRES_OPERATION_WITH_DRIVER_APP: "『GOドライバー』アプリでの操作が必要です",
      OPEN_THE_DRIVER_APP_FROM_YOUR_SMART_PHONE: "スマートフォンから『GOドライバー』アプリを開いてください。",
      LOGIN_AS_DRIVER_NOTICE: "『GOドライバー』アプリと同じアカウントでログインしてください。",
      CHECK_EMAIL_NOTICE: "メールアドレスの注意事項をご確認ください",
      INVALID_EMAIL_ADDRESS_NOTICE_MESSAGE_0:
        "以下に該当するメールアドレスの場合、GO乗務員ポータルからのメールが届きません。",
      INVALID_EMAIL_ADDRESS_NOTICE_MESSAGE_1: "ドメインの受信拒否設定(迷惑メール設定)がされている",
      INVALID_EMAIL_ADDRESS_NOTICE_MESSAGE_2: "特殊な形式のメールアドレスを利用している",
      INVALID_EMAIL_ADDRESS_NOTICE_MESSAGE_3: "詳細は以下のよくある質問を確認してください。",
      WHAT_IS_CONFIRMATION_EMAIL_NOT_ARRIVED: "確認コードのメールが届きません",
      ABOUT_NON_ARRIVAL_OF_CREW_PORTAL_CONFIRMATION_EMAIL: "GO乗務員ポータルからのメールが届きません",
      IF_YOU_DO_NOT_RECEIVE_CONFIRMATION_EMAIL: "メールが届かない場合",
      CHECK_BELOW_FAQ:
        "ドメインの受信拒否設定(迷惑メール設定)がされている場合があります。詳細は以下のよくある質問を確認してください。",
      CONFIRMATION_EMAIL_NOT_ARRIVED: "メール登録エラー",
      DRIVER_SCORE: "お客様からの評価",
      WHAT_IS_DRIVER_SCORE: "お客様からの評価とは?",
      MAINTENANCE_PERIOD: "メンテナンス期間",
      MAINTENANCE_PERIOD_SUFFIX: "頃",
      WHAT_IS_COOKIE_DISABLED: "cookieの設定について",
    },
  },
  en: {
    translation: {
      CREW_PORTAL: "GO Crew Portal",
      DRIVER_PORTAL: "GO Driver Portal",
    },
  },
};

const mergedResources = {
  jp: {
    translation: {
      ...resources.jp.translation,
      ...ErrorTitleResources.jp,
      ...ErrorMessageResources.jp,
      ...PointTransferResources.jp,
      ...PointTransferHisotyResources.jp,
      ...MappingRequestResources.jp,
    },
  },
  en: {
    translation: {
      ...resources.en.translation,
      ...ErrorTitleResources.en,
      ...ErrorMessageResources.en,
      ...PointTransferResources.en,
      ...PointTransferHisotyResources.en,
      ...MappingRequestResources.en,
    },
  },
};

i18n.use(initReactI18next).init({
  resources: mergedResources,
  lng: "jp", // lng: "en"
  fallbackLng: "jp", // fallbackLng: "en"
  interpolation: {
    escapeValue: false,
  },
});
